import {
  Modal,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";
import { X } from "lucide-react";

const WalletInfoModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      {/* Blur Background */}
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />

      <ModalContent
        mx={4}
        borderRadius="2xl"
        bg="white"
        maxH="85vh"
        overflowY="auto"
         className="hide-scrollbar"
      >
        {/* Header */}
        <div className="flex justify-between items-center px-5 pt-5">
          <h2 className="text-xl font-bold text-[#34163F]">
            Wallet Information
          </h2>
          <button onClick={onClose}>
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-4 text-gray-700 text-sm space-y-4">
          <div>
            <h3 className="font-bold text-black mb-1">
              Credit Value
            </h3>
            <p>
              Credits are virtual units used within the platform for
              accessing features like quizzes and contests. They do
              not represent real money.
            </p>
            <ul className="list-disc pl-5 space-y-1 pt-3">
              <li className="text-bgBlue font-bold">100 credits = ₹1</li>
            </ul>
          </div>

          <hr />

          <div>
            <h3 className="font-bold text-black mb-2">
              Withdrawal Rules
            </h3>
            <ul className="list-disc pl-5 space-y-1">
              <li>Minimum withdrawal threshold applies</li>
              <li>Withdrawal requests are processed within 24–48 hours</li>
              <li>Withdrawals are subject to verification and platform policies</li>
              <li>Only KYC verified users can withdraw</li>
            </ul>
          </div>

          <hr />

          <div>
            <h3 className="font-bold text-black mb-2">
              Important Conditions
            </h3>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Credits purchased via Add Funds are non-withdrawable. Only performance-based rewards are eligible for withdrawal.
              </li>
              <li>
                During withdrawal, Credits are used in this order: Contest → Referral → Quiz
              </li>
              <li>
                Quiz Credits are locked for 30 days and cnnot be withdrawn during this period
              </li>
            </ul>

            <p className="text-xs text-gray-700 mt-3 text-center">
              This platform provides skill-based rewards and does not
              involve any form of gambling.
            </p>
          </div>
          <p className="text-gray-500">Credits are used for lerning activities on the platform. Payment are processed securely via trusted partners.</p>
        </div>

        {/* Bottom Button */}
        <div className="p-4">
          <button
            onClick={onClose}
            className="w-full bg-[#34163F] text-white py-3 rounded-full font-semibold"
          >
            Got It
          </button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default WalletInfoModal;